import Component from "@tunnel-components/@pages/supervision/camera/segmentation/home/component";
import * as React from "react";
import * as Utils from "@Cyclope-Utils/index";
import {
  sectionzonesloadedactioncreator,
  sectionzonesloadedresetactioncreator,
  ProgressBarResetActionCreator,
  ProgressBarActionCreator,
  CameraBySectionLoadedActionCreator,
  SectionSwitchSegmentedActionCreator,
  CameraUpdateZoneActionCreator,
  CameraSwitchSegmentedResetActionCreator,
  SectionSwitchSegmentedResetActionCreator,
  CheckCameraZoneMaskActionCreator,
  CameraSwitchSegmentedActionCreator,
} from "@tunnel-store/index";
import { connect } from "react-redux";
import * as Lodash from "lodash";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @method onSubmit
 * @method toggleModal
 * @method onSequence
 * @method onSequenceReinitialization
 * @method onSequenceWarning
 * @method onRegister
 * @method virtualDomUpdate
 * @method onChangeZone
 * @method onAllReinitialization
 * @method onPolygon
 * @method onRemoveDrawPolygon
 * @method onPolygonCoord
 * @method onGetMouseOverCoord
 * @method toggleModalSegmentationTwice
 * @method onResetSection
 * @method nextCameraActivated
 * @method handleToUpdate
 * @method
 * @method componentDidUpdate
 * @method componentWillReceiveProps
 * @method render
 * @infos "https://reactjs.org"
 */

class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 500 millisecondes
  public debounceSequence = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ infos: !this.state.infos }));
  }, 500);
  //  faire cette action toute les 500 millisecondes
  public debounceSequenceWarning = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      warningsequence: !this.state.warningsequence,
    }));
  }, 500);
  //  faire cette action toute les 500 millisecondes
  public debounceSequenceReinitialization = Lodash.debounce((event: any) => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      reinitialisation: !this.state.reinitialisation,
    }));
  }, 500);
  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      activeSequence: [],
      btnloading: false,
      camera: {},
      cameraparams: props.match.params.cameraId,
      check: [],
      coordString: "",
      coordStringMouseOver: "",
      coordToDataScientist: [],
      coords: [],
      errorserver: false,
      infos: false,
      modalSegmentationTwice: false,
      nextCamera: [],
      numberOfcamera: 0,
      progressBarInc: 0,
      reinitialisation: false,
      segmentation: true,
      selectedSectionId: null,
      virtualDom: false,
      warningsequence: false,
      withdrawPolygon: false,
      zone: null,
      zoneArray: [],
      zoneItems: props.getAllZone, // utilisé cette valeur afin d'initializer l'etat de zone
      zonePolygon: false,
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onSubmit = this.onSubmit.bind(this);
    this.onSequence = this.onSequence.bind(this);
    this.onSequenceReinitialization = this.onSequenceReinitialization.bind(
      this
    );
    this.onSequenceWarning = this.onSequenceWarning.bind(this);
    this.onRegister = this.onRegister.bind(this);
    this.virtualDomUpdate = this.virtualDomUpdate.bind(this);
    this.onChangeZone = this.onChangeZone.bind(this);
    this.onAllReinitialization = this.onAllReinitialization.bind(this);
    this.onPolygon = this.onPolygon.bind(this);
    this.onRemoveDrawPolygon = this.onRemoveDrawPolygon.bind(this);
    this.onPolygonCoord = this.onPolygonCoord.bind(this);
    this.onGetMouseOverCoord = this.onGetMouseOverCoord.bind(this);
    this.toggleModalSegmentationTwice = this.toggleModalSegmentationTwice.bind(
      this
    );
    this.onResetSection = this.onResetSection.bind(this);
    this.onResetCamera = this.onResetCamera.bind(this);
    this.nextCameraActivated = this.nextCameraActivated.bind(this);
    this.handleToUpdate = this.handleToUpdate.bind(this);
    this.onSegmentatedCamera = this.onSegmentatedCamera.bind(this);
  }

  /**
   * @function handleToUpdate
   * @param { any } coordToDataScientist
   * @infos "https://reactjs.org"
   */
  public handleToUpdate = (coordToDataScientist: any): void =>
    this.setState((state: any): any => ({ coordToDataScientist }));

  /**
   * @function nextCameraActivated
   * @param { any } event
   * @param { boolean }  active
   * @infos "https://reactjs.org"
   */
  public nextCameraActivated = (active: boolean) => (event: any): void => {
    {
      /** Vérification de l'existence d'une variable */
    }
    if (Lodash.isArray(active)) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ nextCamera: active }));
    }
  };
  /**
   * @function onPolygon
   * @param { number } index
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onPolygon = (index: number, param: number): void => {
    // this.onRemoveDrawPolygon();

    if (param === 1) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ zonePolygon: true }));
    } else {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ zonePolygon: false }));
    }
  };
  /**
   * @function onPolygonCoord
   * @param { any } allPointsX
   * @param { any } allPointsY
   * @infos "https://reactjs.org"
   */
  public onPolygonCoord = (allPointsX: any, allPointsY: any): void => {
    {
      /** Vérification de l'existence d'une variable */
    }
    if (Lodash.isArray(allPointsX) && Lodash.isArray(allPointsY)) {
      /**
       * @constant
       * @description :
       * @name getMousePositions
       * @type any[]
       */
      const getMousePositions: any[] = [];
      /**
       * @constant
       * @description :
       * @name allXcoords
       * @type any[]
       */
      const allXcoords: any[] = [];
      /**
       * @constant
       * @description :
       * @name allYcoords
       * @type any[]
       */
      const allYcoords: any[] = [];
      /**
       * @constant
       * @description :
       * @name path
       * @type string[]
       */
      const path: string[] = ["M", "L", "z"];
      {
        /** boucle */
      }
      for (let i = 0; i < Math.ceil(allPointsX.length); i++) {
        allXcoords[i] = allPointsX[i];
        allYcoords[i] = allPointsY[i];
      }
      {
        /** boucle  */
      }
      for (let i = 1; i < Math.ceil(allPointsX.length); i++) {
        getMousePositions[i] =
          path[1] +
          allPointsX[i].toString().concat(" ", allPointsY[i].toString());
      }

      getMousePositions[0] =
        path[0] +
        allPointsX[0].toString().concat(" ", allPointsY[0].toString());

      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        coordString: getMousePositions.toString() + " z",

        coords: {
          allPointsX: allXcoords.toString(),
          allPointsY: allYcoords.toString(),
        },

        withdrawPolygon: false,
      }));
    }
  };
  /**
   * @function  onGetMouseOverCoord
   * @param { any } allPointsX
   * @param { any } allPointsY
   * @infos "https://reactjs.org"
   */
  public onGetMouseOverCoord = (
    allPointsX: any,
    allPointsY: any,
    lastPosition: any
  ): void => {
    /**
     * @constant
     * @description :
     * @name getMousePositions
     * @type any[]
     */
    const getMousePositions: any[] = [];
    /**
     * @constant
     * @description :
     * @name path
     * @type string[]
     */
    const path: string[] = ["M", "L", "z"];
    getMousePositions[0] =
      path[1] + allPointsX.toString().concat(" ", allPointsY.toString());
    /**
     * @constant
     * @description :
     * @name lineTo
     * @type string
     */
    const lineTo: string =
      path[0] + lastPosition + getMousePositions.toString();
    {
      /** comparaison */
    }
    if (lastPosition !== "") {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        coordStringMouseOver: lineTo,
      }));
    }
  };
  /**
   * @function onChangeZone
   * @param { number } param
   * @param { boolean[] } paramState
   * @infos "https://reactjs.org"
   */
  public onChangeZone = (param: number, paramState: boolean[]): void => {
    /**
     * @constant
     * @description :
     * @name stateId
     * @type number[]
     */
    const stateId: any[] = [1, 2, 3];
    {
      /** comparaison */
    }
    if (paramState[0]) {
      this.props.CameraUpdateZoneActionCreator(this.state, stateId[1]);
    } else if (paramState[1]) {
      this.props.CameraUpdateZoneActionCreator(this.state, stateId[2]);
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ zone: Number(param) }));
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      activeSequence: [],
      btnloading: false,
      camera: {},
      check: [],
      coordString: "",
      coordStringMouseOver: "",
      errorserver: false,
      infos: false,
      modalSegmentationTwice: false,
      withdrawPolygon: false,
      zone: null,
      zonePolygon: false,
    }));

    this.props.ProgressBarResetActionCreator();
    this.props.sectionzonesloadedresetactioncreator();

    // Stopper l'action une fois le component détruit
    this.debounceSequence.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceSequenceWarning.cancel();
    // Stopper l'action une fois le component détruit
    this.debounceSequenceReinitialization.cancel();
  }
  /**
   * @method virtualDomUpdate
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public virtualDomUpdate = (): void =>
    this.setState({ virtualDom: !this.state.virtualDom });

  /**
   * @function onResetCamera
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onResetCamera = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    this.props
      .CameraSwitchSegmentedResetActionCreator(this.props.match.params.cameraId)
      .then(() =>
        this.setState((state: any): any => ({ modalSegmentationTwice: false }))
      )
      .then(() => document.location.reload(true));
  };
  /**
   * @function onResetSection
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onResetSection = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    this.props.ProgressBarResetActionCreator();

    this.props
      .SectionSwitchSegmentedResetActionCreator(this.props.match.params.section)
      .then(() =>
        this.setState((state: any): any => ({ modalSegmentationTwice: false }))
      )
      .then(() => document.location.reload(true));
  };
  /**
   * @method onSequence
   * @param { any } event
   * @infos "https://reactjs.org"
   */

  public onSequence = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceSequence(event);
  };

  /**
   * @method onSequenceWarning
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSequenceWarning = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceSequenceWarning(event);
    // this.setState((state: any):any =>({ warningsequence:!this.state.warningsequence}))
  };

  /**
   * @method onSequenceReinitialization
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSequenceReinitialization = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    /**
     * Afin d'améliorer la performance de l'interface on utilise des actions
     * espacé dans le temps
     */
    this.debounceSequenceReinitialization(event);
    // this.setState((state: any):any =>({  reinitialisation:!this.state.reinitialisation }))
  };

  /**
   * @function onAllReinitialization
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onAllReinitialization(event: any) {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** comparaison */
    }
    if (this.state.zone !== null) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({
        coords: [],
        zone: null,
        coordString: "",
        coordStringMouseOver: "",
      });

      this.props
        .sectionzonesloadedresetactioncreator()
        .then(() =>
          this.props.sectionzonesloadedactioncreator(
            this.props.match.params.section
          )
        );
    }
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      reinitialisation: !this.state.reinitialisation,
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      coordString: "",
      coords: [],
      coordStringMouseOver: "",
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ zonePolygon: false }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ withdrawPolygon: true }));
  }

  /**
   * @function onRemoveDrawPolygon
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public onRemoveDrawPolygon = (): void => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      coordString: "",
      coords: [],
      coordStringMouseOver: "",
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState({ zonePolygon: false });
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ withdrawPolygon: true }));
  };
  /**
   * @function
   * @name onSegmentatedCamera
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSegmentatedCamera = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();

    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      coordString: "",
      coords: [],
      coordStringMouseOver: "",
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ zonePolygon: false }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ withdrawPolygon: true }));
    {
      /** comparaison */
    }
    if (this.state.zone !== null) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ zone: null }));

      this.props
        .sectionzonesloadedresetactioncreator()
        .then(() =>
          this.props.sectionzonesloadedactioncreator(
            this.props.match.params.section
          )
        );
    }
    {
      /** Vérification de l'existence d'une variable */
    }
    if (!Lodash.isUndefined(this.state.camera)) {
      this.props
        .CameraSwitchSegmentedActionCreator(this.state.camera.id)
        .then(() => this.setState((state: any): any => ({ coords: [] })))
        .then(() => this.setState((state: any): any => ({ btnloading: false })))
        .then(() => document.location.reload(true));
    }
  };
  /**
   * @function
   * @name onSubmit
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      coordString: "",
      coords: [],
      coordStringMouseOver: "",
    }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ zonePolygon: false }));
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ withdrawPolygon: true }));
    {
      /** comparaison */
    }
    if (this.state.zone !== null) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ zone: null }));

      this.props
        .sectionzonesloadedresetactioncreator()
        .then(() =>
          this.props.sectionzonesloadedactioncreator(
            this.props.match.params.section
          )
        );
    }
    {
      /** Vérification de l'existence d'une variable */
    }
    if (!Lodash.isUndefined(this.state.camera)) {
      this.props
        .CameraSwitchSegmentedActionCreator(this.state.camera.id)
        .then(() => this.setState((state: any): any => ({ coords: [] })))
        .then(() => {
          this.props.ProgressBarActionCreator().then(() => {
            if (this.state.numberOfcamera !== 0) {
              if (
                Math.ceil(
                  100 *
                    ((this.state.progressBarInc + 1) /
                      this.state.numberOfcamera)
                ) <= 100
              ) {
                if (!Lodash.isUndefined(this.props.sectionCameras)) {
                  {
                    /** Empêcher la mutation du state */
                  }
                  this.setState((state: any): any => ({
                    camera: this.onSortDynamic(
                      this.props.sectionCameras.filter(
                        (element: any) => element.segmented === false
                      )
                    )[this.props.count],
                    progressBarInc: this.props.count,
                  }));
                }
              } else {
                this.props.ProgressBarResetActionCreator();
              }
            }
          });
        })
        .then(() =>
          this.setState((state: any): any => ({ btnloading: false }))
        );
    } else {
      this.props.ProgressBarResetActionCreator();
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    this.props.ProgressBarResetActionCreator();

    // get cameras by section
    this.props
      .CameraBySectionLoadedActionCreator(this.props.match.params.section)
      .then(() => this.onUpdateValue(this.props.sectionCameras));

    // get all mask
    this.props.sectionzonesloadedactioncreator(this.props.match.params.section);
  }
  /**
   * @function onRegister
   * @param { number } param
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onRegister = (param: number) => {
    // event.preventDefault();
    /**
     * @constant
     * @description :
     * @name activeSequence
     * @type any
     */
    const activeSequence: any = this.state.activeSequence;
    /**
     * @constant
     * @description :
     * @name check
     * @type any
     */
    const check: any = this.state.check;

    activeSequence[param + 1] = true;

    check[param] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      activeSequence,
      check,
    }));
  };
  /**
   * @method
   * @name toggleModalSegmentationTwice
   * @param { }
   * @infos "https://reactjs.org"
   */
  public toggleModalSegmentationTwice = () => {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      modalSegmentationTwice: !this.state.modalSegmentationTwice,
    }));

    window.location.assign(`acceuil`);
  };
  /**
   * @method
   * @name onUpdateValue
   * @param { any } Elem
   * @infos "https://reactjs.org"
   */
  public onUpdateValue = (Elem: any) => {
    {
      /** Vérification de l'existence d'une variable */
    }
    if (
      Lodash.isArray(Elem) &&
      !Lodash.isUndefined(Elem) &&
      !Lodash.isNull(Elem)
    ) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (Lodash.isUndefined(this.state.cameraparams)) {
        /**
         * @constant
         * @description :
         * @name cameraTobeSegmented
         * @type any[]
         */
        const cameraTobeSegmented: any[] = this.onSortDynamic(
          Elem.filter((element: any) => element.segmented === false)
        );
        /**
         * @constant
         * @description :
         * @name cameraNumber
         * @type number
         */
        const cameraNumber: number = Elem.filter(
          (element: any) => element.segmented === false
        ).length;

        // const cameraNumber : number = 0 ;
        if (cameraNumber !== 0) {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            camera: cameraTobeSegmented[0],
            numberOfcamera: cameraNumber,
          }));
        } else {
          {
            /** Empêcher la mutation du state */
          }
          this.setState((state: any): any => ({
            camera: null,
            numberOfcamera: 0,
          }));
        }
      } else {
        /**
         * @constant
         * @description :
         * @name cameraTobeSegmented
         * @type any[]
         */
        const cameraTobeSegmented: any[] = this.onSortDynamic(
          Elem.filter(
            (element: any) =>
              element.segmented === false &&
              Number(element.id) === Number(this.state.cameraparams)
          )
        );
        /**
         * @constant
         * @description :
         * @name cameraNumber
         * @type number
         */
        const cameraNumber: number = 1;
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          camera: cameraTobeSegmented[0],
          numberOfcamera: cameraNumber,
        }));
      }
    }
  };
  /**
   * @method
   * @name onSortDynamic
   * @param { any } Elem
   * @return { any }
   * @infos "https://reactjs.org"
   */
  public onSortDynamic = (Elem: any): any => {
    {
      /** Vérification de l'existence d'une variable */
    }
    if (Lodash.isArray(Elem)) {
      return Elem.sort((a: any, b: any) =>
        a.code > b.code ? 1 : b.code > a.code ? -1 : 0
      );
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison des props */
    }
    if (nextProps.error !== this.props.error) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
      {
        /** Comparaison des props */
      }
    } else if (nextProps.sectionCameras !== this.props.sectionCameras) {
      this.onUpdateValue(nextProps.sectionCameras);
      this.props.sectionzonesloadedactioncreator(
        this.props.match.params.section
      );
      {
        /** Comparaison des props */
      }
    } else if (nextProps.getAllZone !== this.props.getAllZone) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (!Lodash.isUndefined(this.props.errorGetAllZone)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison des props */
    }
    if (prevState.camera !== this.state.camera) {
      {
        /** Vérification de l'existence d'une variable */
      }
      if (Lodash.isEmpty(this.state.camera)) {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ modalSegmentationTwice: true }));
        this.props.ProgressBarResetActionCreator();
      } else {
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({ camera: this.state.camera }));
        this.setState((state: any): any => ({ modalSegmentationTwice: false }));
      }
    } else if (prevState.progressBarInc !== this.state.progressBarInc) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        progressBarInc: this.state.progressBarInc,
      }));
    } else if (prevState.zone !== this.state.zone) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ zone: this.state.zone }));
    } else if (prevState.coordString !== this.state.coordString) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        coordString: this.state.coordString,
      }));
    } else if (
      prevState.coordStringMouseOver !== this.state.coordStringMouseOver
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        coordStringMouseOver: this.state.coordStringMouseOver,
      }));
    } else if (prevProps.getAllZone !== this.props.getAllZone) {
      const zone: any[] = Utils.transformObjectToArray(
        this.props.getAllZone
      ).map((elem: any, index: number) => {
        return elem.zoneId;
      });
      {
        /** Empêcher la mutation du state */
      }
      this.setState({ zone: zone[0] });
    } else if (prevState.cameraparams !== this.state.cameraparams) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        cameraparams: this.state.cameraparams,
      }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onChangeZone={this.onChangeZone}
        virtualDomUpdate={this.virtualDomUpdate}
        onRegister={this.onRegister}
        onSequenceReinitialization={this.onSequenceReinitialization}
        onSequenceWarning={this.onSequenceWarning}
        onSequence={this.onSequence}
        onSubmit={this.onSubmit}
        toggleModalSegmentationTwice={this.toggleModalSegmentationTwice}
        {...this.state}
        {...this.props}
        onAllReinitialization={this.onAllReinitialization}
        onPolygon={this.onPolygon}
        onRemoveDrawPolygon={this.onRemoveDrawPolygon}
        onPolygonCoord={this.onPolygonCoord}
        onGetMouseOverCoord={this.onGetMouseOverCoord}
        onResetSection={this.onResetSection}
        nextCameraActivated={this.nextCameraActivated}
        handleToUpdate={this.handleToUpdate}
        onSegmentatedCamera={this.onSegmentatedCamera}
        onResetCamera={this.onResetCamera}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    checkZone: state.CheckCameraZoneMask.data,
    count: state.ProgressBar.count,
    error: state.CameraBySection.error,
    errorGetAllZone: state.SectionZonesLoaded.error,
    getAllZone: state.SectionZonesLoaded.data,
    loading: state.CameraBySection.loading,
    sectionCameras: state.CameraBySection.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  CameraSwitchSegmentedResetActionCreator,
  CheckCameraZoneMaskActionCreator,
  SectionSwitchSegmentedResetActionCreator,
  SectionSwitchSegmentedActionCreator,
  CameraUpdateZoneActionCreator,
  CameraSwitchSegmentedActionCreator,
  sectionzonesloadedactioncreator,
  ProgressBarResetActionCreator,
  CameraBySectionLoadedActionCreator,
  ProgressBarActionCreator,
  sectionzonesloadedresetactioncreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/segmentation/home/container.tsx